import OlinLogo from "../assets/olinfull.png";
import DefaultBanner from "../assets/Banner.png";
import OrlinLogo from "../assets/Orlin/orlin-logo.PNG";
import OrlinBanner from "../assets/Orlin/orlin-banner.jpeg";

const labelConfig = {
  "apotek-test009.pharmaniaga.tech": {
    brandName: "Olin",
    logo: OlinLogo,
    banner: DefaultBanner,
  },
  "apotek-apa.pharmaniaga.tech": {
    brandName: "Orlin",
    logo: OrlinLogo,
    banner: OrlinBanner,
  },
  "apotekmillennium.pharmaniaga.tech": {
    brandName: "Orlin",
    logo: OrlinLogo,
    banner: OrlinBanner,
  },
  "orlin-demo.pharmaniaga.tech": {
    brandName: "Orlin",
    logo: OrlinLogo,
    banner: OrlinBanner,
  },
  "orlin.psefolin.co.id": {
    brandName: "Orlin",
    logo: OrlinLogo,
    banner: OrlinBanner,
  },
};

export const getLabelConfig = () => {
  const hostname = window.location.hostname;

  return (
    labelConfig[hostname] || {
      brandName: "Olin",
      logo: OlinLogo,
      banner: DefaultBanner,
    }
  );
};
